import React, { Fragment, ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import ButtonLink from "../../../../components/buttonLink/ButtonLink";
import { logout } from "../../../login/login.actions";
import { Button } from "../../../../components/button/Button";

interface ErrorPageContentProps {
  title?: ReactNode;
  children: ReactNode;
}

const ErrorPageContent = ({ title, children }: ErrorPageContentProps) => {
  return (
    <Fragment>
      {title && <h1 className="error-page__title">{title}</h1>}
      <div className="error-page__message">{children}</div>
    </Fragment>
  );
};

export const GeneralErrorContent = () => {
  return (
    <ErrorPageContent title={<FormattedMessage id={"error_page_title"} />}>
      <FormattedMessage id={"error_page_msg_1"} />
      <ButtonLink onClick={() => window.location.reload()}>
        <FormattedMessage id={"reload"} />
      </ButtonLink>
      <FormattedMessage id={"error_page_msg_2"} />
    </ErrorPageContent>
  );
};

export const AccountErrorContent = () => {
  const dispatch = useDispatch();

  const doLogout = () => {
    dispatch(logout());
  };

  return (
    <ErrorPageContent>
      <p>
        <FormattedMessage id={"account_not_exist"} />
      </p>
      <p>
        <FormattedMessage id={"contact_administrator"} />
      </p>
      <Button onClick={doLogout}>
        <FormattedMessage id={"go_back"} />
      </Button>
    </ErrorPageContent>
  );
};

export const ErrorBoundaryContent = () => {
  return (
    <ErrorPageContent title={<FormattedMessage id={"error_page_title"} />}>
      <FormattedMessage id={"error_page_msg_1"} />
      <ButtonLink onClick={() => window.location.reload()}>
        <FormattedMessage id={"reload"} />
      </ButtonLink>
      <FormattedMessage id={"error_page_msg_2"} />
    </ErrorPageContent>
  );
};
